import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import buildDurationChart from './build-duration-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-duration-chart-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();

const buildDurationChartConfig = useDashboard().workloads.buildDurationChart;
const options = computed(() => ({
  ...buildDurationChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: buildDurationChartConfig,
        chartId: buildDurationChartConfig.value.chartId,
        componentInstance: buildDurationChart,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(buildDurationChart, {
    "chart-options": {
      ..._unref(buildDurationChartConfig),
      options: _unref(options),
    }
  }, null, 8, ["chart-options"]))
}
}

})